var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm._id,
      "hide-footer": "",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function(ref) {
        var close = ref.close;

        return [_c('div', {
          staticClass: "w-100 d-flex justify-content-end"
        }, [_c('span', {
          staticClass: "cursor-pointer float-right",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function($event) {
              return close()
            }
          }
        }, [_c('b-icon-x-circle')], 1)])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "bg-danger mx-1",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("\n      Back\n    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button mx-1",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleSuccess
    }
  }, [_vm._v("\n      OK\n    ")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc6276c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Notifications/Modal.vue
// module id = 6uJm
// module chunks = 2